import React, { useState } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import PropTypes from 'prop-types';
import { huntingFarmingFilterOptions } from '../../constants/master-entities';

const HuntingFarmingFilter = ({ setHuntingFarmingCallback }) => {
  const filterOptions = huntingFarmingFilterOptions('Todos los negocios');
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[0].value);
  const setHuntingFarming = (e) => {
    setSelectedFilter(e.target.value);
    setHuntingFarmingCallback(filterOptions.find((type) => type.value === e.target.value).value);
  };

  return (
    <FormControl sx={{ m: 1, minWidth: 115 }}>
      <Select
        name="filterType"
        value={selectedFilter}
        onChange={setHuntingFarming}
      >
        {filterOptions.map((filter) => (
          <MenuItem
            value={filter.value}
            key={filter.key}
          >
            {filter.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

HuntingFarmingFilter.propTypes = {
  setHuntingFarmingCallback: PropTypes.func,
};

HuntingFarmingFilter.defaultProps = {
  setHuntingFarmingCallback: () => {},
};

export default HuntingFarmingFilter;
